import { useQuery } from "@tanstack/react-query";
import { processShifts } from "@utils/nurse-util";
import httpClient from "@/config/axios";
import { QUERY_KEYS } from "@/constants/QUERY_KEYS";

export type ShiftResponse = {
  allday: number;
  auto_schedule: number;
  color: string;
  default_shift: string;
  duration: number | null;
  end_time: number | null;
  id: number; //매핑기준
  name: string;
  description?: string | null;
  sequence: number;
  shift_gb: string;
  shift_id: string;
  show_in_preference: boolean;
  off_swap_target?: boolean;
  start_time: number;
  type: string;
};

export type ShiftReturnType = ReturnType<typeof processShifts>;

export function useShiftsQuery(
  groupId?: string,
  options?: { enabled?: boolean }
) {
  return useQuery<ShiftReturnType>({
    queryKey: QUERY_KEYS.shifts.list(groupId),
    queryFn: async () => {
      const params: { group_id?: string } = {};
      if (groupId) params.group_id = groupId;
      const res = await httpClient.get<ShiftResponse[]>(`/shifts`, {
        params,
      });

      return processShifts(res);
    },
    enabled: options?.enabled ?? true,
    staleTime: 5 * 60 * 1000,
    retry: 0,
    retryDelay: 1000,
  });
}
